/* The Alt Art Co - quick add + cart drawer suggestions.
   Adds via /cart/add.js, then fires Horizon's own CartLinesUpdateEvent so the drawer, header badge and
   multi-buy bar re-render exactly as if the product form had been used (and the drawer auto-opens). */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const variantFor = async (el) => {
  if (el.dataset.variant) return +el.dataset.variant;
  const handle = new URL(el.dataset.handleUrl, location.origin).pathname.split('/products/')[1].split(/[/?#]/)[0];
  const p = await fetch(`/products/${handle}.js`).then((r) => r.json());
  const v = p.variants.find((x) => x.available) || p.variants[0];
  el.dataset.variant = v.id;
  return v.id;
};

async function quickAdd(btn) {
  if (btn.disabled) return;
  btn.disabled = true; btn.classList.add('is-busy');
  const label = btn.innerHTML;
  try {
    const id = await variantFor(btn);
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((e) => e.dataset.sectionId).filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product',
      lines: [{ merchandiseId: String(id), quantity: 1 }], promise: deferred.promise }));
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }) });
    const data = await res.json();
    if (!res.ok) { deferred.reject(new Error(data.description || 'add failed')); throw new Error(data.description); }
    const cart = await fetch('/cart.js').then((r) => r.json());
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'product-form-component', itemCount: 1, sections: data.sections, didError: false } });
    if (location.pathname === '/cart') { location.reload(); return; }
    // slide the basket open (unless the click came from inside it)
    const trigger = document.querySelector('button[aria-controls="cart-drawer"]');
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true' && !btn.closest('cart-drawer-component, #cart-drawer')) setTimeout(() => trigger.click(), 250);
    btn.classList.add('is-done'); btn.innerHTML = btn.dataset.aacQaCard !== undefined ? '✓' : '✓ Added';
    btn.setAttribute('aria-label', 'Added to basket');
    setTimeout(() => { btn.classList.remove('is-done'); btn.innerHTML = label; btn.removeAttribute('aria-label'); btn.disabled = false; btn.classList.remove('is-busy'); }, 1800);
  } catch (e) {
    btn.disabled = false; btn.classList.remove('is-busy');
    btn.innerHTML = label;
  }
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-aac-qa]');
  if (!btn) return;
  e.preventDefault(); e.stopPropagation();
  quickAdd(btn);
});

/* ---- product cards: wrap each <a class="aac-card"> and add a sibling "+" button (no button inside a link) ---- */
const enhance = (root) => {
  root.querySelectorAll?.('a.aac-card[href*="/products/"]:not([data-aac-qa-done])').forEach((a) => {
    a.dataset.aacQaDone = 1;
    const wrap = document.createElement('div'); wrap.className = 'aac-cardwrap';
    a.parentNode.insertBefore(wrap, a); wrap.appendChild(a);
    const name = (a.querySelector('.aac-card__title')?.textContent || 'this set').trim();
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'aac-qa'; b.dataset.aacQa = ''; b.dataset.aacQaCard = '';
    b.dataset.handleUrl = a.getAttribute('href');
    b.innerHTML = '<span aria-hidden="true">+</span>';
    b.setAttribute('aria-label', `Add ${name} to basket`);
    wrap.appendChild(b);
  });
};
enhance(document);
new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && enhance(n.matches?.('a.aac-card') ? n.parentNode : n))))
  .observe(document.body, { childList: true, subtree: true });

/* ---- cart drawer: swap bestseller fallback for "More from <set>" ---- */
class AacDrawerRecs extends HTMLElement {
  connectedCallback() { this.load(); }
  load() {
    const set = this.dataset.set; if (!set || this.dataset.loadedFor === set + location.search) return;
    const q = `tag:"${set}"`;
    fetch(`/search?type=product&options[unavailable_products]=hide&q=${encodeURIComponent(q)}&section_id=aac-drawer-recs`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        const list = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-aac-drecs-list]');
        if (!list || !list.children.length) return;
        this.querySelector('[data-aac-drecs-list]').innerHTML = list.innerHTML;
        this.dataset.loadedFor = set + location.search;
      }).catch(() => {});
  }
}
if (!customElements.get('aac-drawer-recs')) customElements.define('aac-drawer-recs', AacDrawerRecs);
/* the drawer morphs on every cart change: re-check suggestions afterwards */
document.addEventListener(StandardEvents.cartLinesUpdate, () => setTimeout(() => document.querySelectorAll('aac-drawer-recs').forEach((r) => { delete r.dataset.loadedFor; r.load(); }), 900), true);
